export default "__VITE_ASSET__3eb8ac69__"